import { Typography } from "antd";
import styled from "styled-components";

export const NarrationText = styled(Typography.Text)<{ $isRTL?: boolean }>`
  font-size: 14px;
  font-style: italic;
  color: #000;
  line-height: 1.5;
  display: block;
  direction: ${({ $isRTL }) => ($isRTL ? "rtl" : "ltr")};
  text-align: ${({ $isRTL }) => ($isRTL ? "right" : "left")};
`;
